// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA2XNcUUXbGT9LDWVtSHUlZtl0F0dYEhYM",
  authDomain: "cte-rsvp.firebaseapp.com",
  projectId: "cte-rsvp",
  storageBucket: "cte-rsvp.firebasestorage.app",
  messagingSenderId: "741299085271",
  appId: "1:741299085271:web:a348019a274debfb60b592"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Check if a user is an admin
export const isAdmin = async (uid) => {
  if (!uid) return false;
  
  try {
    const adminRef = doc(db, 'adminUsers', uid);
    const adminDoc = await getDoc(adminRef);
    return adminDoc.exists();
  } catch (error) {
    console.error("Error checking admin status:", error);
    return false;
  }
};

export { app, db, storage, auth };